<template>
  <div class="font-tip">
    <el-tooltip class="item" effect="dark" :placement="placement">
      <div slot="content">
        <p class="tip" v-for="item in tips">
          {{item}}
        </p>
      </div>
      <i :class="iconClass"></i>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: {
      'tip': {
        type: [String, Array]
      },
      'iconClass': {
        type: String,
        default: 'iconfont icon-shuoming'
      },
      'placement': {
        type: String,
        default: 'right-start'
      }
    },
    data () {
      return {
        tips: []
      };
    },
    created () {
      if (typeof this.tip === "string") {
        this.tips.push(this.tip);
      } else {
        this.tips = this.tip;
      }
    }
  };
</script>

<style lang="less">
  .font-tip {
    display: inline !important;
    .tip {
      line-height: 30px;
    }
    .icon-shuoming {
      color: #016cdf;
    }
  }
</style>



// WEBPACK FOOTER //
// FontTip.vue?69081702